import { Toggle } from '@components/Toggle'
import { ToggleFieldProps } from './interface'

export function ToggleField({ handleChangeValue, ...props }: ToggleFieldProps) {
  return <Toggle {...props} onChange={handleChangeValue} />
}
